import React, { useEffect } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { StateProvider, useStateValue } from '@State'
import { client } from '@Utils'
import { badges as endpoints } from '@URLS'
import { routePaths, linkPaths, COURSENUM, OBJECT_ID } from '../urls'
import { Review } from './Review'
import { Requirements } from './Requirements'
import { Design } from './Design'

const initialState = {
  badgeInfo: {
    name: 'Badge Name',
    incompleteImage: '',
    incompleteImageName: '',
    incompleteImageLoaded: false, // true if image is loaded from server or from file upload input
    incompleteNewUploadedImage: false, // true if image is loaded from file upload input
    completeImage: '',
    completeImageName: '',
    completeImageLoaded: false, // true if image is loaded from server or from file upload input
    completeNewUploadedImage: false, // true if image is loaded from file upload input
    selectedAssessments: [],
    selectedChapters: [],
    selectedVideos: [],
    passingScore: '50',
    retrievedEditData: false,
    description: '',
    requireNewPrereqs: false,
  },
  assessments: {},
  chapters: {
    id: '',
    title: '',
    chapterChoices: [],
  },
  videos: {
    id: '',
    title: '',
    videoChoices: [],
  },
  finished: false,
  errors: [],
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_BADGE_INFO':
      return {
        ...state,
        badgeInfo: { ...state.badgeInfo, ...action.badgeInfo },
      }
    case 'UPDATE_ASSESSMENTS':
      return {
        ...state,
        assessments: action.assessments,
      }
    case 'PUSH_ASSESSMENTS':
      return {
        ...state,
        badgeInfo: {
          ...state.badgeInfo,
          selectedAssessments: action.selectedAssessments,
        },
      }
    case 'UPDATE_CHAPTERS':
      return {
        ...state,
        chapters: action.chapters,
      }
    case 'PUSH_CHAPTERS':
      return {
        ...state,
        badgeInfo: {
          ...state.badgeInfo,
          selectedChapters: action.selectedChapters,
        },
      }
    case 'UPDATE_VIDEOS':
      return {
        ...state,
        videos: action.videos,
      }
    case 'PUSH_VIDEOS':
      return {
        ...state,
        badgeInfo: {
          ...state.badgeInfo,
          selectedVideos: action.selectedVideos,
        },
      }
    case 'PUSH_PASSING_SCORE':
      return {
        ...state,
        badgeInfo: { ...state.badgeInfo, passingScore: action.passingScore },
      }
    case 'FINISH_BADGE':
      return {
        ...state,
        finished: true,
      }
    case 'SET_ERRORS':
      return {
        ...state,
        errors: action.errors,
      }
    default:
      return state
  }
}

function AppContent() {
  const [state, dispatch] = useStateValue()

  useEffect(() => {
    const loadData = async () => {
      if (OBJECT_ID && !state.badgeInfo.retrievedEditData) {
        try {
          const response = await client.get(endpoints.show({ id: OBJECT_ID }))
          dispatch({
            type: 'UPDATE_BADGE_INFO',
            badgeInfo: { ...response.data, retrievedEditData: true },
          })
        } catch (err) {
          console.error(`Error fetching badge info`, err)
        }
      }

      try {
        const response = await client.get(endpoints.assessments())
        dispatch({ type: 'UPDATE_ASSESSMENTS', assessments: response.data })
      } catch (err) {
        console.error(`Error fetching assessments`, err)
      }

      try {
        const response = await client.get(endpoints.chapters())
        dispatch({ type: 'UPDATE_CHAPTERS', chapters: response.data })
      } catch (err) {
        console.error(`Error fetching chapters`, err)
      }

      try {
        const response = await client.get(endpoints.videos())
        dispatch({ type: 'UPDATE_VIDEOS', videos: response.data })
      } catch (err) {
        console.error(`Error fetching videos`, err)
      }
    }
    loadData()
  }, [])

  if (state.finished) {
    window.location = `/instructor/achievements/${COURSENUM}/`
  }

  return (
    <div
      id="body_section"
      className="row position-relative p-0 my-5 mx-3 mx-sm-5"
    >
      <section id="body_section_center" className="border bg-light m-0 pt-3">
        <Switch>
          <Route path={routePaths.design} component={Design} />
          <Route path={routePaths.requirements} component={Requirements} />
          <Route path={routePaths.review} component={Review} />
          <Redirect from={routePaths.wizard} to={linkPaths.design} />
        </Switch>
      </section>
    </div>
  )
}

export function App() {
  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <AppContent />
    </StateProvider>
  )
}
